import { Navigation } from "@shopify/polaris";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { MenuListDataShipper, MenuListDataShipperLogic } from "src/MenuItems";
import { ContextUser } from "src/context/ContextUser";
// import PolarisMenu from "src/services/PolarisMenu";
import { StarFilledMinor } from "@shopify/polaris-icons";
import { useTranslation } from "react-i18next";
import { useSellerMenu } from "src/services/provider/SellerMenuProvider";
import useWindowDimensions from "src/hooks/useWindow";
import { useToggle } from "src/services/provider/ToggleProvider";
import styles from "./style.module.scss";

function callMenuByRole(role: string): any[] {
  switch (role) {
    case "LOGISTIC_SHIPPER":
      return MenuListDataShipperLogic;
    case "SHIPPER":
      return MenuListDataShipper;
    case "SELLER":
      return [];
    case "STORE":
      return [];
    case "VENDOR":
      return [];
    default:
      return [];
  }
}

export function NavigationDesktop() {
  const { t } = useTranslation();
  const { listen } = useHistory();
  const { MenuShopify } = useSellerMenu();
  const [path, setPath] = useState(window.location.pathname);
  const { merchant } = useContext(ContextUser);
  const { width } = useWindowDimensions();
  const { open, setOpen } = useToggle();
  const menus = callMenuByRole(merchant.role || "").length === 0 ? MenuShopify : callMenuByRole(merchant.role || "");

  useEffect(() => {
    listen((location) => {
      setPath(location.pathname);
    });
  }, [listen]);
  // return <div></div>;

  // if (callMenuByRole(merchant.role || "").length === 0) {
  //   return <Spinner size="small" />;
  // }

  return (
    <div style={{ backgroundColor: "rgba(235, 235, 235, 1" }}>
      {(width || 0) > 770 ? (
        <div
          className={styles["double-toggle"]}
          onClick={() => {
            setOpen(!open);
          }}
        >
          <img
            src={open ? "/assets/icons8-double-left-52-dark.png" : "/assets/icons8-double-right-52-dark.png"}
            style={{ width: 17 }}
            alt=""
          />
        </div>
      ) : undefined}
      <Navigation location={window.location.pathname}>
        {menus
          .filter((x) => !!x.header)
          .map((x, i) => {
            const items = menus
              .filter((s) => !s.header && s.id === x.id)
              .map((x) => {
                let selected = x.id === "dashbord" && !path;

                if (!selected) {
                  selected = path === x.to;
                }

                return {
                  url: x.to,
                  label: t(x.name),
                  icon: x.icon ? x.icon : StarFilledMinor,
                  selected,
                  subNavigationItems: x.subs
                    ? x.subs.map((s: any) => {
                        return {
                          url: s.to,
                          label: t(s.name),
                          badge: s.count && s.count > 0 ? s.count + "" : undefined,
                        };
                      })
                    : [],
                  secondaryAction: x.secondaryAction ? x.secondaryAction : null,
                  badge: x.count && x.count > 0 ? x.count + "" : undefined,
                };
              });

            if (items.length === 0) {
              return <div key={i}></div>;
            }

            return (
              <Navigation.Section
                key={i}
                separator={i === 0 ? false : true}
                title={t(x.name)}
                items={items.map((x: any) => {
                  return {
                    ...x,
                    icon: x.icon as any,
                  };
                })}
              />
            );
          })}
      </Navigation>
    </div>
  );
}
